import { Routes } from "@angular/router";

export const appRoutes: Routes = [
    {
        path: "",
        redirectTo: "auth/login",
        pathMatch: "full"
    },
    {
        path: "auth",
        loadChildren: () => import("./main/authentication/authentication.module").then((m) => m.AuthenticationModule)
    },
    {
        path: "cadastros",
        loadChildren: () => import("./main/cadastros/cadastros.module").then((m) => m.CadastrosModule)
    },
    {
        path: "webhooks",
        loadChildren: () => import("./main/webhooks/webhooks.module").then((m) => m.WebhooksModule)
    },
    {
        path: "EAD",
        loadChildren: () => import("./main/EAD/EAD.module").then((m) => m.EADModule)
    },
    {
        path: "permissoes",
        loadChildren: () => import("./main/permissoes/permissoes.module").then((m) => m.PermissoesModule)
    },
    {
        path: "pagamentos",
        loadChildren: () => import("./main/pagamentos/pagamentos.module").then((m) => m.PagamentosModule)
    },
    {
        path: "fiscal",
        loadChildren: () => import("./main/fiscal/fiscal.module").then((m) => m.FiscalModule)
    },
    {
        path: "configuracoes",
        loadChildren: () => import("./main/settings/settings.module").then((m) => m.SettingsModule)
    },
    {
        path: "trusteeship",
        loadChildren: () => import("./main/trusteeship/trusteeship.module").then((m) => m.TrusteeshipModule)
    },
    {
        path: "home",
        loadChildren: () => import("./main/home/home.module").then((m) => m.HomeModule)
    },
    {
        path: "storage",
        loadChildren: () => import("./main/storage/storage.module").then((m) => m.StorageModule)
    },
    {
        path: "gamification",
        loadChildren: () => import("./main/gamification/gamification.module").then((m) => m.GamificationModule)
    },
    {
        path: "relatorios",
        loadChildren: () => import("./main/relatorios/relatorios.module").then((m) => m.RelatoriosModule)
    },
    {
        path: "registrations",
        loadChildren: () => import("./main/registrations/registrations.module").then((m) => m.RegistrationsModule)
    },
    {
        path: "**",
        redirectTo: "home"
    }
];
